
import { BaseMixin } from "@/mixins/baseMixin";

export default class MaintenanceMode extends BaseMixin {
  public name: string = "MaintenanceMode";
}
